// ALTCHA web component'i Vite ile bundle'a girer (CDN yok, kapalı ağda çalışır).
// PoW worker'ı paket içinde inline blob olarak gelir.
import "altcha";
import { t } from "i18next";
import React, { useEffect, useMemo, useRef } from "react";
import { getCaptchaChallengeUrl } from "../services/auth.api";
import styles from "../styles/login.module.scss";

interface LoginCaptchaProps {
  /**
   * Çözülen payload (base64) ya da çözüm geçersizleşince (süre doldu, hata,
   * sıfırlandı) `null`.
   */
  onChange: (payload: string | null) => void;
}

type AltchaStateDetail = { state?: string; payload?: string };

/**
 * Self-hosted ALTCHA proof-of-work doğrulaması (pentest 3.3.2).
 *
 * Yalnızca backend `captchaRequired` bildirdiğinde render edilir. Payload tek
 * kullanımlıktır; parent her denemeden sonra `key` değiştirerek bileşeni yeniden
 * mount eder → yeni challenge çekilir ve otomatik çözülür.
 */
const LoginCaptcha: React.FC<LoginCaptchaProps> = ({ onChange }) => {
  const widgetRef = useRef<HTMLElement>(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const challengeUrl = useMemo(() => getCaptchaChallengeUrl(), []);
  const strings = useMemo(
    () =>
      JSON.stringify({
        label: t("login.captcha.label"),
        verifying: t("login.captcha.verifying"),
        verified: t("login.captcha.verified"),
        error: t("login.captcha.error"),
        expired: t("login.captcha.expired"),
        verificationRequired: t("login.captcha.verificationRequired"),
        waitAlert: t("login.captcha.waitAlert"),
        ariaLinkLabel: t("login.captcha.label"),
        footer: "",
      }),
    [],
  );

  useEffect(() => {
    const el = widgetRef.current;
    if (!el) return undefined;

    const handleStateChange = (ev: Event) => {
      const detail = (ev as CustomEvent<AltchaStateDetail>).detail || {};
      if (detail.state === "verified" && detail.payload) {
        onChangeRef.current(detail.payload);
      } else {
        onChangeRef.current(null);
      }
    };

    el.addEventListener("statechange", handleStateChange);
    return () => {
      el.removeEventListener("statechange", handleStateChange);
      onChangeRef.current(null);
    };
  }, []);

  return (
    <div className={styles["login-captcha"]}>
      <altcha-widget
        ref={widgetRef}
        challengeurl={challengeUrl}
        auto="onload"
        hidelogo
        hidefooter
        strings={strings}
      />
    </div>
  );
};

export default LoginCaptcha;
